import styled from 'styled-components';
import { borders, colors, shadows, spacings } from '../../styles/theme';

export const FormContainer = styled.div`
  background: ${colors.white};
  border-radius: ${borders.lg};
  box-shadow: ${shadows.lg};
  width: 500px;
  max-height: 90vh;
  overflow-y: auto;
`;

export const FormContent = styled.div`
  padding: ${spacings.xl};
  
  h3 {
    margin: 0 0 ${spacings.lg} 0;
    color: ${colors.neutral_darkest};
    text-align: center;
  }
`;

export const FormActions = styled.div`
  display: flex;
  gap: ${spacings.md};
  justify-content: flex-end;
  margin-top: ${spacings.lg};
  
  button {
    min-width: 120px;
  }
`;

export const ErrorMessage = styled.div`
  background-color: #fee;
  border: 1px solid #fcc;
  border-radius: ${borders.sm};
  color: #c33;
  padding: ${spacings.md};
  margin-bottom: ${spacings.lg};
  font-size: 0.9rem;
  
  h4 {
    margin: 0 0 ${spacings.sm} 0;
    font-size: 1rem;
  }
  
  p {
    margin: 0;
    line-height: 1.4;
  }
`;
